import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminMailInspection = lazy(() => import("@/pages/admin/AdminMailInspection"));

export const Route = createFileRoute("/admin/mejlgranskning")({
  component: () => <AdminMailInspection />,
});
